"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _AdaptiveCardBuilder = _interopRequireDefault(require("./AdaptiveCardBuilder"));

var _AdaptiveCardRenderer = _interopRequireDefault(require("./AdaptiveCardRenderer"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var CommonCard =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CommonCard, _React$Component);

  function CommonCard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CommonCard);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CommonCard).call(this, props));
    _this.buildCard = (0, _memoizeOne.default)(function (adaptiveCards, content, styleOptions) {
      var builder = new _AdaptiveCardBuilder.default(adaptiveCards, styleOptions);
      builder.addCommon(content);
      return builder.card;
    });
    return _this;
  }

  (0, _createClass2.default)(CommonCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCardHostConfig = _this$props.adaptiveCardHostConfig,
          adaptiveCards = _this$props.adaptiveCards,
          _this$props$attachmen = _this$props.attachment;
      _this$props$attachmen = _this$props$attachmen === void 0 ? {} : _this$props$attachmen;
      var content = _this$props$attachmen.content,
          options = _this$props.styleSet.options;
      return _react.default.createElement(_AdaptiveCardRenderer.default, {
        adaptiveCard: content && this.buildCard(adaptiveCards, content, options),
        adaptiveCardHostConfig: adaptiveCardHostConfig,
        tapAction: content && content.tap
      });
    }
  }]);
  return CommonCard;
}(_react.default.Component);

CommonCard.propTypes = {
  adaptiveCardHostConfig: _propTypes.default.any.isRequired,
  adaptiveCards: _propTypes.default.any.isRequired,
  attachment: _propTypes.default.shape({
    content: _propTypes.default.shape({
      tap: _propTypes.default.any
    }).isRequired
  }).isRequired,
  styleSet: _propTypes.default.any.isRequired
};

var _default = (0, _botframeworkWebchatComponent.connectToWebChat)(function (_ref) {
  var styleSet = _ref.styleSet;
  return {
    styleSet: styleSet
  };
})(CommonCard);

exports.default = _default;